export const STALE_TIME = Infinity;
